import React from "react";
import { Route } from "react-router-dom";
import useUserStore from "../../stores/user";
import NotFound from "../NotFound";

// Residual pages are gated on canViewResidualData alone, not on the
// EntityAdminRoute pair (isEntitySuperAdmin || isDashboardAllowedOrgAdmin).
//
// canViewResidualData is isConfiguredForResidualData() computed server-side, so
// this guard and every residual endpoint answer the same question: the toggle
// for everyone, plus a split and a rep ID for an agent. The pair it replaces
// asked a different one — isDashboardAllowedOrgAdmin keys off the org's
// replica_org_id, which no residual endpoint consults, so an entity org with no
// replica counterpart (PaymentCloud Inc, org 1) rendered NotFound here for
// agents the API would have served.
const ResidualRoute = ({ component: Component, render, children, ...rest }) => {
  const canViewResidualData = useUserStore(
    (state) => state.canViewResidualData,
  );
  const userLoading = useUserStore((state) => state.userLoading);

  if (children) {
    return (
      <Route {...rest}>
        {userLoading ? null : canViewResidualData ? children : <NotFound />}
      </Route>
    );
  }

  return (
    <Route
      {...rest}
      render={(props) => {
        if (userLoading) {
          return null;
        }
        if (!canViewResidualData) {
          return <NotFound />;
        }
        if (Component) {
          return <Component {...props} />;
        }
        if (render) {
          return render(props);
        }
        return null;
      }}
    />
  );
};

export default ResidualRoute;
